export default `Region,Population
Amazonas,389700
Ancash,1039415
Apurímac,418882
Arequipa,1140810
Ayacucho,619338
Cajamarca,1359023
Callao,810568
Cusco,1171503
Huancavelica,447054
Huánuco,730871
Ica,665592
Junín,1091619
La Libertad,1539774
Lambayeque,1091535
Lima,864853
Loreto,884144
Madre de Dios,92024
Moquegua,159306
Pasco,266764
Piura,1630772
Puno,1245508
San Martín,669973
Tacna,274496
Tumbes,191713
Ucayali,402445`